import { IAppRoute } from 'interfaces/route';
import { userRoles } from 'interfaces/user';
import { PureComponent } from 'react';

import Dashboard from './Dashboard';
import DashboardEntity from './Dashboard/View/Entity';
import DashboardVenture from './Dashboard/View/Venture';
import EntityRouter from './entityRouter';
import AnalyticalReport from './Report/Analytical';

import { ReactComponent as DashboardIcon } from 'assets/icons/menu/dashboard.svg';
import { ReactComponent as AnalyticalReportIcon } from 'assets/icons/menu/relatorio-analitico.svg';
import { ReactComponent as ModulesIcon } from 'assets/icons/menu/modulos.svg';

export default class DocumentationRouter extends PureComponent {
  public static routes: IAppRoute[] = [
    {
      path: '/dashboard',
      sideDrawer: { display: 'Dashboard', order: 1, icon: DashboardIcon },
      exact: true,
      roles: [userRoles.sysAdmin, userRoles.admin, userRoles.auditor, userRoles.holding, userRoles.venturer, userRoles.operator, userRoles.third],
      isProfileSelectedDependent: true,
      component: Dashboard
    },
    {
      path: '/dashboard/venture/:ventureId',
      exact: true,
      roles: [userRoles.sysAdmin, userRoles.admin, userRoles.auditor, userRoles.holding, userRoles.venturer, userRoles.operator, userRoles.third],
      isProfileSelectedDependent: true,
      component: DashboardVenture
    },
    {
      path: '/dashboard/venture/:ventureId/entity/:entityId',
      exact: true,
      roles: [userRoles.sysAdmin, userRoles.admin, userRoles.auditor, userRoles.holding, userRoles.venturer, userRoles.operator, userRoles.third],
      isProfileSelectedDependent: true,
      component: DashboardEntity
    },
    {
      path: '/files',
      sideDrawer: { display: 'Módulos', order: 2, icon: ModulesIcon },
      isProfileSelectedDependent: true,
      roles: [userRoles.admin, userRoles.auditor, userRoles.holding, userRoles.venturer, userRoles.operator, userRoles.visitor, userRoles.third],
      subMenuDefault: 'open',
      component: EntityRouter
    },

    {
      path: '/analytical',
      sideDrawer: { display: 'Relatório Analítico', order: 3, icon: AnalyticalReportIcon },
      roles: [userRoles.admin, userRoles.auditor, userRoles.holding, userRoles.venturer, userRoles.operator, userRoles.third],
      component: AnalyticalReport
    },
  ];

  render() {
    return (this.props.children);
  }
}
